import { ErrorMessage, Field, useFormikContext } from "formik";
import Heading from "../Heading";
import { sectionSettings } from "../../Helpers/WindowHelpers";
import Input from "../Fields/Input";

interface OrderDetailsInterface {

}

const OrderDetails = ({ }: OrderDetailsInterface) => {
    const context = useFormikContext<any>();
    return (
        <>
            <Heading
                level={4}
                text={sectionSettings.order_details_label} />
            <div className="d--flex gap-20">
                <Input 
                    name="po_number" 
                    type="text" 
                    label={sectionSettings.po_number_label} 
                    placeholder={sectionSettings.po_number_placeholder} />
                <Input 
                    name="client_name" 
                    type="text" 
                    label={sectionSettings.client_name_label} 
                    placeholder={sectionSettings.client_name_placeholder} />
            </div>
        </>
    );
}

export default OrderDetails;